<template>
  <div class="header-top" :class="{'is-login': is_login}">
    <div class="head-content d-flex d-flex-between d-flex-middle">
      <div class="d-flex d-flex-middle logo-box" @click="toHome">
        <img :src="tenantInfo.logo" class="logo" alt="">
        <p class="schoolName">{{ tenantInfo.websiteName }}</p>
      </div>
      <!-- <a href="javascript:void(0)" class="bmBtn" v-if="is_login" @click="toBm">新考生报名</a> -->
      <!-- <div class="d-flex d-flex-middle certi-download" v-if="loginStatus">
        <span>准考证下载：</span>
        <el-select v-model="defaultThesisBatchId" placeholder="请选择批次" size="mini">
          <el-option v-for="item in configs" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-button type="primary" @click="downloadCerti" size="mini">下载</el-button>
      </div> -->
    </div>
  </div>
</template>

<script>
import vueQr from "vue-qr";
import { mapState } from "vuex"

export default {
  components: {
    vueQr,
  },
  props: {
    is_login: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      router: true,
      scrolledDistance: 0,
      title: process.env.VUE_APP_BASE_TITLE,
      loginStatus: false,
      configs:[],
      defaultThesisBatchId: ''
    }
  },
  computed: {
    ...mapState(['tenantInfo', 'schoolInfo', 'user'])
  },
  created() {
    this.$store.dispatch("fetchSchoolConfig");
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.loginStatus = this.user ? true : false;
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      const distance = window.pageYOffset || window.scrollTop;
      this.scrolledDistance = distance;
      if (this.scrolledDistance > 50) { // 100px的滚动距离
        // 改变CSS，例如添加一个class
        document.querySelector('.head-content').classList.add('baseForm-s');
      } else {
        // 移除CSS class
        document.querySelector('.head-content').classList.remove('baseForm-s');
      }
    },
    toBm() {
      this.$router.push({ path: '/bm' });
    },
    toHome() {
      if(localStorage.getItem('token')){
        this.$router.push({ path: '/main/home' });
      }else{
        this.$router.push({ path: '/' });
      }
    },
    downloadCerti() {
      console.log(this.defaultThesisBatchId);
    }
  },
};
</script>
<style lang="scss" scoped>
@import "@/variable.scss";
.header-top {

  // background: linear-gradient(0deg, rgb(252, 251, 251) 0%, $primary 100%);
  background: url(../assets/top-bg.png) no-repeat;
  background-size: 100% 220px;
  height: 100px;
  margin-bottom: -70px;
  &.is-login {
    background: url(../assets/top-bg_.png) no-repeat;

  }
  .head-content {
    display: flex;
    align-items: center;
    background: transparent;
    height: 100px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    width: 100%;
    box-sizing: border-box;
    padding: 0 calc(50% - 600px);
    .logo-box{
      cursor: pointer;
    }

    // background: url("../assets/home_icon01.png") no-repeat;
    .logo {
      height: 56px;
    }

  }

  .baseForm-s {
    //background: linear-gradient(0deg, rgb(252, 251, 251) 0%, $primary 100%);
    background: url(../assets/top-bg.png) no-repeat;
    background-size: 100% 220px;
  }
}
.schoolName{
  line-height: 56px;
  color: #fff; 
  font-size: 24px;
  margin-left: 20px;
}
.bmBtn{
  color: #fff;
  font-size: 12px;
  height: 32px;
  line-height: 32px;
  border: 1px solid #fff;
  border-radius: 4px;
  padding: 0 8px;
}
.certi-download{
  span{
    color: #fff;
    font-size: 12px;
  }
  .el-button{
    margin-left: 10px;
    background: #FF8F1F;
  }
}
</style>